import React from 'react';
import { IoMdInformationCircle } from 'react-icons/io';

import { Container } from './styles';

interface IStepMenuDataOs {
  setContentData: React.Dispatch<React.SetStateAction<string>>;
}

const WarningCompleteData: React.FC<IStepMenuDataOs> = ({ setContentData }) => (
  <Container>
    <div className="col-md-12 d-flex">
      <div className="icon-information">
        <IoMdInformationCircle size={40} color="#FEBA6A" />
      </div>
      <div className="col-md-11 text-box">
        <div className="d-flex mt-3">
          <b>Complete seus dados para prosseguir</b>
        </div>
        <div className="d-flex mt-3 row box-fill">
          <div className="col-xl-8">
            <p>Preencha seus dados e dos proponentes</p>
          </div>

          <div className="col-xl-4 box-button-fill">
            <button
              type="button"
              className="button-fill px-5 py-2 mb-1"
              onClick={() => setContentData('DataProponent')}
            >
              <b>Preencher</b>
            </button>
          </div>
        </div>
      </div>
    </div>
  </Container>
);

export default WarningCompleteData;
